import Resource from '../utils/resource'

export default new Resource('/CourseMarketplacePayments', {
  getCourseMarketplacesPromptpayQrcode: {
    url: 'qr-promptpay',
    method: 'post',
  },
})
